import baseForRight from './_baseForRight.js';
import keys from './keys.js';

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

export default baseForOwnRight;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseForOwnRight.js
// module id = 559
// module chunks = 67